import React, { useState } from "react";
import LocalFocusedOcr from "./components/LocalFocusedOcr";
import DocOcrUploader from "./components/DocOcrUploader";

export default function OcrPage() {
  const [last, setLast] = useState(null);

  return (
    <div className="p-6 space-y-6">
      <h1 className="text-2xl font-bold">OCR</h1>

      <section>
        <h2 className="text-xl font-semibold mb-2">Live skeniranje (segment)</h2>
        <LocalFocusedOcr
            pattern={/[A-Z]{2}-\d{5}/}
            /* promeni po potrebi */
            onResult={setLast}
        />
        {last && (
          <div className="mt-3 text-sm">
            <div><b>Tip:</b> {last.type}</div>
            <div><b>Match:</b> {last.match || "—"}</div>
            <div className="opacity-60"><b>Raw:</b> {last.raw}</div>
          </div>
        )}
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">Dokumenti (upload → server)</h2>
        <DocOcrUploader />
      </section>
    </div>
  );
}
